import moment from 'moment';
import {
    CommissionStatementMetadata,
    MonthDataMetadata,
    MonthTypeInString,
    MonthStatementDataType,
    StatementMonthType,
    SummaryDetails,
    MonthOption
} from '../../types/GenrateMonthStatements';
import { MAX_MONTH_COUNT, MAX_YEAR, MONTHS_DATA } from '../Constants/Constants';

export const GenerateTwoYearMonthStatements = () => {
    const date = moment(),
        previousYearData: MonthStatementDataType[] = [];

    let currentYear:number = Number(date.format('YYYY')),
        currentMonth:number = date.month(),
        maxMonth:number = MAX_MONTH_COUNT,
        previousYear:number = currentYear - 1;

    while (currentYear >= MAX_YEAR) {
        for (let i = 0; i < MONTHS_DATA.length; i++) {
            let indexInString = (currentMonth + 1).toString(),
                statementMonth = indexInString.length === 1 ? '0' + indexInString : indexInString,
                data: MonthStatementDataType = {
                    statementMonth: statementMonth as StatementMonthType,
                    statementYear: `${currentYear}`,
                    statementMonthString: MONTHS_DATA[currentMonth] as MonthTypeInString,
                    value: `${currentYear}${statementMonth}`
                };
            if (currentMonth >= 0 && maxMonth >= 1 && currentYear >= previousYear) {
                previousYearData.push(data);
                maxMonth -= 1;
                currentMonth -= 1;
            }
        }
        currentYear -= 1;
        currentMonth = 11;
    }
    return [...previousYearData].reverse();
};

export const GenerateMonthStatements = (summary: SummaryDetails) => {
    const previousYearData: MonthStatementDataType[] = [];

    if (summary?.referral_graph_details && summary.referral_graph_details.length > 0) {
        for (const item of summary.referral_graph_details) {
            const statementMonth: StatementMonthType = item.calendarmonth.toString().padStart(2, '0') as StatementMonthType;
            const statementYear: string = item.calendaryear.toString();
            const statementMonthString: MonthTypeInString = MONTHS_DATA[item.calendarmonth - 1] as MonthTypeInString;
            const value: string = `${statementYear}${statementMonth}`;

            previousYearData.push({
                statementMonth,
                statementYear,
                statementMonthString,
                value
            });
        }
    }

    return previousYearData;
};

export const GenerateReferralsMonthStatements = (monthData: MonthOption[]) => {
    const previousYearData: MonthStatementDataType[] = [];
    const date = moment();
    const currentYear: number = Number(date.format('YYYY'));
    const currentMonth: number = date.month() + 1;

    const getStatementData = (calendarMonth: number, calendarYear: number) => {
        const statementMonth: StatementMonthType = calendarMonth.toString().padStart(2, '0') as StatementMonthType;
        const statementYear: string = calendarYear.toString();
        const statementMonthString: MonthTypeInString = MONTHS_DATA[calendarMonth - 1] as MonthTypeInString;
        const value: string = `${statementYear}${statementMonth}`;

        return {
            statementMonth,
            statementYear,
            statementMonthString,
            value
        };
    };

    const pushCurrentMonthData = () => {
        previousYearData.push(
            getStatementData(currentMonth, currentYear)
        );
    }

    if (monthData.length > 0) {
        const { calendarmonth: latestCalendarMonth, calendaryear: latestCalendarYear } = monthData[0];
        const isCurrentMonthAvailable: boolean = latestCalendarMonth === currentMonth && latestCalendarYear === currentYear;

        !isCurrentMonthAvailable && pushCurrentMonthData();

        for (const item of monthData) {
            previousYearData.push(getStatementData(item.calendarmonth, item.calendaryear));
        }
    } else {
        pushCurrentMonthData();
    }

    return previousYearData;
};

export const GenerateMonthStatementsForCommission = (commisisondataObject: { stmt_month_dropdown_values: CommissionStatementMetadata[]; } | undefined) => {
    const twentyFourMonthData: [] | MonthStatementDataType[] = GenerateTwoYearMonthStatements();
    const commissionMonthData: CommissionStatementMetadata[] = [];
    commisisondataObject && commisisondataObject.stmt_month_dropdown_values.forEach((Commisisondata) => {
        twentyFourMonthData && twentyFourMonthData.forEach((monthData: MonthDataMetadata) => {
            const statementmonth = Commisisondata.statementmonth.toString().length === 1 ? Commisisondata.statementmonth.toString().padStart(2, '0') : Commisisondata.statementmonth.toString();
            const statementYear = Commisisondata.statementyear.toString();
            if (statementmonth === monthData.statementMonth && statementYear === monthData.statementYear) {
                commissionMonthData.push(Commisisondata);
            }
        })
    })
    return commissionMonthData;
};